module.exports = __webpack_public_path__ + "media/images/zoom-icon-196dd695720627b44bd991e401a8794a.jpg";